import { hasValidBrowserSession, tokenKey } from './browser-session';

const link = document.getElementById('public-account-link');
let checkId = 0;

function showAccount(authenticated) {
    link.href = authenticated ? '/web' : '/web/login';
    link.textContent = authenticated ? link.dataset.accountLabel : link.dataset.signinLabel;
}

async function refreshAccountLink() {
    const currentCheck = ++checkId;
    showAccount(false);
    const authenticated = await hasValidBrowserSession();
    if (currentCheck === checkId) showAccount(authenticated);
}

if (link) {
    refreshAccountLink();
    window.addEventListener('pageshow', refreshAccountLink);
    window.addEventListener('focus', refreshAccountLink);
    window.addEventListener('storage', event => {
        if (event.key === tokenKey) refreshAccountLink();
    });
}
